import { useRef, useState } from 'react';
import { useClickOutside } from 'common/hooks';
import { FilterLines } from 'pages/TongQuan/icons';
import { ArrowUp } from 'components/icons';
import IconCheck from 'containers/menu/panoMenu/iconCheck';

export const FilterSelect = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleBtnRef = useRef(null);

  const dropdownRef = useClickOutside(() => setIsOpen(false), [toggleBtnRef]);

  // Check if a filter should be shown as active
  const isFilterActive = (filterId) => {
    // If in "show all" mode, all filters are active
    if (props.isShowAllMode) {
      return true;
    }
    return props.currentFilters.includes(filterId);
  };

  // Handle filter click
  const handleFilterClick = (filter) => {
    // Call window.focusTo with orientation if available
    if (
      filter.defaultOrientation &&
      typeof window !== 'undefined' &&
      typeof window.focusTo === 'function'
    ) {
      window.isFocusToCall = true;
      window.focusTo(...filter.defaultOrientation);
    }

    if (props.onToggleFilter) {
      props.onToggleFilter(filter.id);
    } else if (props.onChangeFilter) {
      // Fallback to original behavior
      props.onChangeFilter({
        currentTarget: {
          dataset: {
            id: filter.id,
            orientation: filter.defaultOrientation
              ? JSON.stringify(filter.defaultOrientation)
              : undefined,
          },
        },
      });
    }
  };

  return (
    <div className="filter-select">
      <button
        ref={toggleBtnRef}
        className={`filter-select-trigger ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div>
          <FilterLines size={18} color="#5F5552" />
          <span>Filters</span>
        </div>
        <ArrowUp />
      </button>
      {isOpen && (
        <div ref={dropdownRef} className="filter-select-dropdown">
          {props.filterItems.map((filter) => {
            const Icon = filter.icon;
            const isActive = isFilterActive(filter.id);
            return (
              <button
                className={`filter-button ${isActive ? 'active' : ''}`}
                onClick={() => handleFilterClick(filter)}
              >
                <div>
                  <Icon color={isActive ? '#5db6b9' : '#5F5552'} />
                  <span>{filter.label}</span>
                </div>
                <IconCheck
                  size={12}
                  color={isActive ? '#5db6b9' : '#5F5552'}
                  className="filter-select-icon-check"
                />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
